import {
	CREATE_ASSIGNMENT,
	GET_ASSIGNMENT,
	GET_EACH_ASSIGNMENT,
	CLEAR_ASSIGNMENT,
	DELETE_ASSIGNMENT,
	UPDATE_ASSIGNMENT,
	GENERATE_SCRIPT,
	CREATE_SCRIPT_ASSIGNMENT,
	UPDATE_SCRIPT_ASSIGNMENT,
	DELETE_SCRIPT_ASSIGNMENT,
	GET_SCRIPT,
	CLEAR_SCRIPT
} from "../ActionTypes"

const initialState = {
	assignment: [],
	eachassignment: [],
	loading: true,
	loadingscript: false,
	loadingsave: false,
	loadingdelete: false,
	LastEvaluatedKeyAssignment: {},
	LastEvaluatedKeyeachAssignment: {},
	script: []
}

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case CREATE_ASSIGNMENT + "_FULFILLED":
			return { ...state, loading: false }
		case CREATE_ASSIGNMENT + "_PENDING":
			return { ...state, loading: true }
		case CREATE_ASSIGNMENT + "_REJECTED":
			return { ...state, loading: false }
		case GET_ASSIGNMENT + "_FULFILLED":
			return {
				...state,
				assignment: payload.data.getAssignment.data,
				LastEvaluatedKeyAssignment: payload.data.getAssignment.next_token,
				loading: false
			}
		case GET_ASSIGNMENT + "_PENDING":
			return { ...state, loading: true }
		case GET_ASSIGNMENT + "_REJECTED":
			return { ...state, loading: false }
		case GET_EACH_ASSIGNMENT + "_FULFILLED":
			return {
				...state,
				eachassignment: payload.data.getAssignment.data,
				LastEvaluatedKeyeachAssignment: payload.data.getAssignment.next_token,
				loading: false
			}
		case GET_EACH_ASSIGNMENT + "_PENDING":
			return { ...state, loading: true }
		case GET_EACH_ASSIGNMENT + "_REJECTED":
			return { ...state, loading: false }
		case DELETE_ASSIGNMENT + "_FULFILLED":
			return { ...state, loading: false }
		case DELETE_ASSIGNMENT + "_PENDING":
			return { ...state, loading: true }
		case DELETE_ASSIGNMENT + "_REJECTED":
			return { ...state, loading: false }
		case UPDATE_ASSIGNMENT + "_FULFILLED":
			return { ...state, loading: false }
		case UPDATE_ASSIGNMENT + "_PENDING":
			return { ...state, loading: true }
		case UPDATE_ASSIGNMENT + "_REJECTED":
			return { ...state, loading: false }
		case GENERATE_SCRIPT + "_FULFILLED":
			return { ...state, loading: false }
		case GENERATE_SCRIPT + "_PENDING":
			return { ...state, loading: true }
		case GENERATE_SCRIPT + "_REJECTED":
			return { ...state, loading: false }
		case CREATE_SCRIPT_ASSIGNMENT + "_FULFILLED":
			return { ...state, loadingsave: false }
		case CREATE_SCRIPT_ASSIGNMENT + "_PENDING":
			return { ...state, loadingsave: true }
		case CREATE_SCRIPT_ASSIGNMENT + "_REJECTED":
			return { ...state, loadingsave: false }
		case UPDATE_SCRIPT_ASSIGNMENT + "_FULFILLED":
			return { ...state, loadingsave: false }
		case UPDATE_SCRIPT_ASSIGNMENT + "_PENDING":
			return { ...state, loadingsave: true }
		case UPDATE_SCRIPT_ASSIGNMENT + "_REJECTED":
			return { ...state, loadingsave: false }
		case DELETE_SCRIPT_ASSIGNMENT + "_FULFILLED":
			return { ...state, loadingdelete: false }
		case DELETE_SCRIPT_ASSIGNMENT + "_PENDING":
			return { ...state, loadingdelete: true }
		case DELETE_SCRIPT_ASSIGNMENT + "_REJECTED":
			return { ...state, loadingdelete: false }
		case GET_SCRIPT + "_FULFILLED":
			return { ...state, script: payload.data.getScript, loadingscript: false }
		case GET_SCRIPT + "_PENDING":
			return { ...state, loadingscript: true }
		case GET_SCRIPT + "_REJECTED":
			return { ...state, loadingscript: false }
		case CLEAR_SCRIPT:
			return {
				...state,
				script: []
			}
		case CLEAR_ASSIGNMENT:
			return {
				...state,
				assignment: [],
				LastEvaluatedKeyAssignment: {}
			}
		default:
			return state
	}
}
